import React from "react";
import {
  ActivityContainer,
  ActivityContainerOuter,
  ActivityTitle,
  ActivityCardContainer,
} from "./Activity.styled";
import ActivityCard from "./ActivityCard";
import SliderWrapper from "../../../../components/atoms/SliderWrapper";

const Activity = ({
  data = [],
  isMobileView,
  imgPath,
  onClickCard,
  backgroundImage,
}) => {
  // Determine whether to use a wrapped layout or a scrollable layout based on viewport and data length
  const shouldWrap = !isMobileView && data.length <= 2;

  return (
    <ActivityContainer
      backgroundImage={backgroundImage}
      isMobileView={isMobileView}
    >
      <ActivityContainerOuter isMobileView={isMobileView}>
        <ActivityTitle isMobileView={isMobileView}>Activity</ActivityTitle>

        {isMobileView || data.length <= 3 ? (
          // Mobile view or desktop view with 3 or fewer items
          <ActivityCardContainer
            isMobileView={isMobileView}
            isWrap={shouldWrap}
          >
            {data.map((item, index) => (
              <ActivityCard
                key={index}
                title={item.title}
                imgSrc={
                  imgPath
                    ? imgPath +
                      (isMobileView ? item.key_visual_mobile : item.key_visual)
                    : item.image_url
                }
                isMobileView={isMobileView}
                onClick={() => onClickCard && onClickCard(item)}
              />
            ))}
          </ActivityCardContainer>
        ) : (
          // Desktop view with more than 3 items - use slider
          <SliderWrapper
            showDotsIndicator={false}
            showItems={3}
            step={1}
            fixStep
            style={{
              width: "100%",
            }}
            cardWrapperStyle={{ width: "100%" }}
            totalData={data.length || 0}
          >
            {({ _, cardWidth }) => (
              <>
                {data.map((item, index) => (
                  <ActivityCard
                    key={index}
                    title={item.title}
                    cardWidth={cardWidth - 3}
                    imgSrc={
                      imgPath
                        ? imgPath +
                          (isMobileView
                            ? item.key_visual_mobile
                            : item.key_visual)
                        : item.image_url
                    }
                    isMobileView={isMobileView}
                    onClick={() => onClickCard && onClickCard(item)}
                  />
                ))}
              </>
            )}
          </SliderWrapper>
        )}
      </ActivityContainerOuter>
    </ActivityContainer>
  );
};

export default Activity;
